export default "__VITE_ASSET__jkkXmXMF__"